module.exports = __webpack_public_path__ + "img/pdf_sample.0db653b2.png";